<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-02-22 16:29:54
-->
<template>
<a-spin :spinning='loading'>
  <div class="site-box">
    <a-tree
      v-model="checkedKeys"
      checkable
      :auto-expand-parent="autoExpandParent"
      :tree-data="treeData"
      :checkStrictly="true"
    />
    <a-button v-if="this.codeData.indexOf('283') != -1" @click="submitSite" class="btn-box" type="primary">
      保存
    </a-button>
  </div>
  </a-spin>
</template>

<script>
import {siteTree,selectListByOrgId,saveConfig} from './organizational_structure'
export default {
  data() {
    return {
      treeData: [],
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      loading:false,
      codeData: [],
    };
  },
  components: {},
  props:['organizationId'],
  mounted() {
    this.treeList();
    this.selectKeys();
     this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  watch:{
    organizationId(){
       this.treeList();
        this.selectKeys();
    }
  },
  methods: {
     treeList(){
        siteTree({}).then((res)=>{
                if(res.code == 0){
                        let options = JSON.stringify(res.data)
                        .replace(/name/g, "title")
                        .replace(/id/g, "key");
                        this.treeData = JSON.parse(options)
                }
                
        })
     },
     selectKeys(){
            this.loading = true;
            selectListByOrgId({
                id:this.organizationId,
            }).then((res)=>{
                if(res.code == 0){
                        let array = [];
                        for (let index = 0; index < res.data.length; index++) {
                            const element = res.data[index];
                            array.push(element.siteId)
                        }
                        this.checkedKeys = array;
                }
                 this.loading = false;
            })
     },
     siteRole(){
        return this.checkedKeys;
     },
    submitSite(){
        saveConfig({
             id:this.organizationId,
             idList:this.checkedKeys.checked || this.checkedKeys,
        }).then((res)=>{
            if(res.code == 0){
                this.selectKeys();
            }
        })
    },
  },
};
</script>

<style lang="less" scoped>
    .site-box{
        padding-left: 16px;
    }
    .btn-box{
        margin-top: 24px;
    }
    /deep/ .ant-tree{
        max-height: 468px;
        overflow-y: auto;
    }
</style>